<template>
  <div class="container">
    <el-form
      ref="form"
      :model="form"
      :rules="realRules"
      @submit.native.prevent="handleSubmit"
    >
      <el-row
        class="row"
        align="middle"
        :gutter="20"
      >
        <el-col
          :span="4"
          class="stepTitle"
        >
          <span class="label">{{ $t('loginUrl.title') }}</span>
        </el-col>
        <el-col
          :span="17"
          :offset="2"
        >
          <el-form-item prop="sandboxHomePageUrl">
            <el-input
              tabindex="1"
              v-model.trim="form.sandboxHomePageUrl"
              :disabled="skipAccount || status === 'connecting' || status === 'checking'"
              :placeholder="skipAccount ? $t('loginUrl.skipped') : $t('loginUrl.placeholder')"
              @blur="handleBlur"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <url-check
        ref="urlCheck"
        v-if="form.sandboxHomePageUrl"
        :url="form.sandboxHomePageUrl"
        v-model="status"
        :retry="handleRetry"
      />
    </div>
    <div
      class="skipAccount"
      v-if="skipShow"
    >
      <el-switch
        :disabled="status === 'connecting' || status === 'checking'"
        v-model="skipAccount"
        active-color="#F56C6C"
      />
      <div class="tipText">{{ $t('loginUrl.skipAccountTip') }}</div>
    </div>
  </div>
</template>

<script>
import UrlCheck from './url-check';

export default {
  name: 'ProjectCode',
  components: {
    UrlCheck,
  },
  props: {
    payload: Object,
  },
  data() {
    const { sandboxHomePageUrl = '', skipAccount = false, restLoginUrlList = [] } = this.payload || {};

    return {
      form: {
        sandboxHomePageUrl,
      },
      realRules: {
        sandboxHomePageUrl: [
          { required: true, message: this.$t('loginUrl.validationMessage'), trigger: 'blur' },
          {
            type: 'url',
            message: this.$t('loginUrl.invalidUrl'),
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (restLoginUrlList.includes(value)) {
                callback(new Error(this.$t('loginUrl.restLoginUrlError')));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      skipAccount,
      status: '',
      skipShow: !restLoginUrlList.length,
    };
  },
  watch: {
    'form.sandboxHomePageUrl'(val) {
      if (val) {
        this.$emit('next-disabled', false);
        this.resetStatus();
      } else if (!this.skipAccount) {
        this.$emit('next-disabled', true);
      }
    },
    skipAccount(val) {
      if (val) {
        this.form.sandboxHomePageUrl = '';
        this.status = '';
        this.$refs.form.clearValidate();
        this.$emit('next-disabled', false);
      } else if (!this.form.sandboxHomePageUrl) {
        this.$emit('next-disabled', true);
      }
    },
    status(val) {
      if (val === 'connecting' || val === 'checking') {
        this.$emit('next-loading', true);
      } else {
        this.$emit('next-loading', false);
      }
    },
  },
  methods: {
    handleBlur() {
      const { sandboxHomePageUrl } = this.form;

      // 去掉 url 中的参数
      if (sandboxHomePageUrl.includes('?')) {
        this.form.sandboxHomePageUrl = sandboxHomePageUrl.split('?')[0];
      }
    },
    resetStatus() {
      if (this.status) {
        this.status = '';
        this.$refs.form.clearValidate();
        this.$emit('next-disabled', false);
      }
    },
    handleSubmit() {
      this.$emit('next');
    },
    handleRetry() {
      this.$refs.urlCheck.getWebsiteScreenshot();
    },
    next() {
      if (this.skipAccount) {
        return {
          stage: 'LoginUrl',
          data: {
            sandboxHomePageUrl: '',
            skipAccount: true,
          },
        };
      }

      if (!this.form.sandboxHomePageUrl) {
        this.$refs.form.validate();
        return;
      }

      if (this.status === 'connecting' || this.status === 'checking') {
        return;
      }

      if (this.status === 'success') {
        return {
          stage: 'LoginUrl',
          data: {
            sandboxHomePageUrl: this.form.sandboxHomePageUrl,
          },
        };
      }

      this.$refs.form.validate().then(() => {
        this.$refs.urlCheck.getWebsiteScreenshot();
      });
    },
  },
  mounted() {
    if (!this.form.sandboxHomePageUrl && !this.skipAccount) {
      this.$emit('next-disabled', true);
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  @media screen and (max-width: 1440px) {
    .info {
      font-size: 14px;
    }
  }

  display: flex;
  flex-direction: column;
  height: 100%;

  .waningText {
    display: inline-block;
    margin-right: 10px;
    background: url(~@assets/images/warning.png) no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
  }

  .row {
    line-height: 40px;
  }

  .rowCenter {
    display: flex;
    align-items: center;
  }

  .label {
    font-weight: bold;
  }

  .placeholder {
    display: block;
    height: 20px;
  }

  .info {
    color: #909399;
  }

  .progress {
    margin-top: 20px;
    width: 80%;
    margin: 0 auto;
  }

  .infoWrapper {
    margin-top: 40px;
  }

  .textCenter {
    text-align: center;
  }

  .errorContent {
    width: fit-content;
    margin: 0 auto;
  }

  .stageIcon {
    font-size: 20px;
    color: #909399;
  }

  .errorIcon {
    color: #f56c6c;
    font-size: 20px;
  }

  .successIcon {
    color: #67c23a;
    font-size: 20px;
  }

  .diagList {
    line-height: 2em;
  }

  .errorTip {
    color: #ff001f;
    margin-top: 20px;

    &.success {
      color: #909399;
    }
  }

  .ipWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ipLabel {
    margin-right: 20px;
  }

  .ipContent {
    margin-right: 40px;
  }

  .successContent {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .el-icon-success {
      margin-right: 40px;
    }
  }

  .ipText {
    margin-right: 20px;
    font-weight: bold;
  }

  .questionIcon {
    display: inline-block;
  }

  .imageWrapper {
    display: flex;
    justify-content: center;
  }
}

.skipAccount {
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 20px;
  padding-bottom: 30px;
  align-self: center;

  .tipText {
    width: 400px;
    white-space: normal;
    margin-left: 20px;
  }
}
</style>